import { initPageCollect, reportUrl } from '@tencent/smp-tools';
import {
  UButton, UImage
} from '@tencent/smp-ui';
import React from 'react';
import DefaultSmp from './defaultSmpData';
import './index.scss';
class Index extends React.Component {
  constructor() {
    super();
    this.state = window.RENDER_DATA || {};
    this.btnRef = React.createRef();
  }

  handleReport({ action = '', subkey = '' }) {
    const { stat = '' } = this.state;
    reportUrl
      && reportUrl({
        statUrl: stat,
        action,
        subkey,
      });
  }

  componentDidMount() {
    const { stat = '', channel } = window.RENDER_DATA || DefaultSmp;
    initPageCollect({
      statUrl: stat,
    });
    window.browser?.app?.newAndLiveReport?.({
      business: 'smp-common-page',
      eventName: 'LAUNCH_FINISH',
      url: location.href,
    });
  }

  handleBtnReady() {
    // 判断是否需要展示顶部应用信息
    const { appStatus, progress } = this.btnRef?.current?.getAppStatus();
    this.setState({ appStatus, progress });
  }

  renderAppInfo() {
    const { appStatus } = this.state;
    const { app = {} } = window.RENDER_DATA || {};

    if (appStatus === 6) {
      return null;
    }

    const { appname, qbversion, qbupdatetime, developer, access, privacy } =
      this.getAppLinkInfo(app.packagename);

    return (
      <div
        style={{
          fontSize: 10,
          margin: 0,
          padding: 6,
          textAlign: 'center',
          width: '100%',
          background: '#fff',
          bottom: 0,
          zIndex: 10000,
        }}
      >
        <p style={{ margin: 0, padding: 2 }}>
          <span style={{ paddingRight: 4 }}>
            应用名称：{appname} 版本：{qbversion}
          </span>
          <span>更新时间：{qbupdatetime}</span>
        </p>
        <p style={{ margin: 0, padding: 2 }}>
          开发者：{developer} &nbsp;
          <a
            style={{ color: 'gray', textDecoration: 'underline' }}
            href={access}
          >
            权限信息
          </a>{' '}
          &nbsp;
          <a
            style={{ color: 'gray', textDecoration: 'underline' }}
            href={privacy}
          >
            隐私协议
          </a>
        </p>
      </div>
    );
  }

  getAppLinkInfo(packagename) {
    if (packagename === 'sogou.mobile.explorer') {
      return {
        appname: '搜狗浏览器极速版',
        qbversion: '12.0.0.1018',
        qbupdatetime: '2021/12/06',
        developer: '北京搜狗科技发展有限公司',
        access:
          'http://rule.tencent.com/rule/preview/fd7014e2-5e1b-47c8-8998-ce439cd90d05',
        privacy:
          'https://rule.tencent.com/rule/preview/ace4720a-c474-47cb-9800-1e83fff6a382',
      };
    }

    if (packagename === 'com.sogou.reader.free') {
      return {
        appname: '搜狗免费小说极速版',
        qbversion: '12.0.0.1014',
        qbupdatetime: '2021/12/06',
        developer: '北京搜狗科技发展有限公司',
        access:
          'https://docs.qq.com/doc/p/1a5d01edb2b2023b54abd2ef34370726b4c6766b?dver=2.1.27266726',
        privacy:
          'https://static.res.qq.com/nav/sogoureader/sogoureader_privacy.html',
      };
    }

    if (packagename === 'com.sohu.inputmethod.sogou') {
      return {
        appname: '搜狗输入法',
        qbversion: '11.17',
        qbupdatetime: '2023/03/02',
        developer: '北京搜狗科技发展有限公司',
        access:
          'https://shouji.sogou.com/wap/htmls/privacy_policy_permission_description.html',
        privacy:
          'https://shouji.sogou.com/wap/htmls/privacy_policy.html',
      };
    }

    // 默认走‘QQ浏览器'
    return {
      appname: 'QQ浏览器',
      qbversion: window.qbversion || '13.9.6.6053',
      qbupdatetime: window.qbupdatetime || '2023/06/01',
      developer: '腾讯科技（深圳）有限公司',
      access: 'https://upage.imtt.qq.com/app-info/qb.html',
      privacy: 'https://privacy.qq.com/document/preview/2491347092a64d7fa00cbc2bf68fbbbb',
    };
  }

  render() {
    const { btn, app = {}, stat, bg } = window.RENDER_DATA || {};
    // 合规要求
    const formatApp = {
      ...app,
      auto: false,
      autoActive: false,
      canpause: true,
    };
    return (
      <div className="App">
        <div className="img-cont">
          <UImage ui={bg} />
        </div>
        <div className="btn-cont">
          <UButton
            ui={btn}
            app={formatApp}
            stat={stat}
            ref={this.btnRef}
            onBtnReady={this.handleBtnReady.bind(this)}
          />
        </div>
        <div className="fixed-footer">{this.renderAppInfo()}</div>
      </div>
    );
  };
}
export default Index;
